// store/actions/BranchActions.js
import {
  CONFIRMED_CREATE_BRANCH_ACTION,
  CONFIRMED_DELETE_BRANCH_ACTION,
  CONFIRMED_EDIT_BRANCH_ACTION,
  CONFIRMED_GET_BRANCHES,
} from "../actions/BranchTypes";

import {
  createBranch,
  formatBranches,
  getBranches,
  deleteBranch,
  updateBranch,
} from "../../services/BranchesService";

import swal from "sweetalert";
import { handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";

// Get token from Redux or fallback to localStorage
function getAuthToken(getState) {
  const stateToken = getState().auth?.authKey;
  if (stateToken) return stateToken;

  const storedUser = localStorage.getItem("userDetails");
  return storedUser ? JSON.parse(storedUser).token : null;
}

// export function getBranchesAction(pagination = true, pageid = 0,search_by = "", search_keyword = "",sort_by = "",sort_order="") {
//   return async (dispatch, getState) => {
//     try {
//       const response = await getBranches(pagination, pageid,search_by,search_keyword,sort_by,sort_order);

//       if (response && response.status === 200 && response.data) {
//         if (response.data.status === "success" && response.data.data) {
//           const branches = formatBranches(response.data.data);
//           dispatch({ type: CONFIRMED_GET_BRANCHES, payload: branches });
//         } else {
//           showErrorAlert("Failed to get branches: Server error");
//         }
//       } else {
//         showErrorAlert("Failed to get branches: Network error",);
//       }
//     } catch (error) {
//       console.error("API Error:", error.response || error);
//       showErrorAlert("Failed to get branches",);
//     }
//   };
// }
export function getBranchesAction(
  pagination = true,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return async (dispatch, getState) => {
    try {
      const response = await getBranches(
        pagination,
        pageid,
        search_by,
        search_keyword,
        sort_by,
        sort_order
      );
      
      if (response && response.status === 200 && response.data) {
        if (response.data.status === "success" && response.data.data) {
          const branches = formatBranches(response.data.data);
          dispatch({
            type: CONFIRMED_GET_BRANCHES,
            payload: {
              branches: branches,
              num_rows: response.data.num_rows || 0
            }
          });
        } else {
          showErrorAlert("Failed to get branches: Server error");
        }
      } else {
        showErrorAlert("Failed to get branches: Network error");
      }
    } catch (error) {
      console.error("API Error:", error.response || error);
      showErrorAlert("Failed to get branches");
    }
  };
}

export function deleteBranchAction(branch, history) {
  return async (dispatch) => {
    try {
      await deleteBranch(branch);
      dispatch({
        type: CONFIRMED_DELETE_BRANCH_ACTION,
        payload: { branch_id: branch.branch_id },
      });
      if (history) history.push("/branchpage");
      handleSuccess("Branch deleted successfully!");
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to delete branch");
    }
  };
}

export function createBranchAction(branchData) {
  return async (dispatch) => {
    try {
      const singleBranch = {
        branch_name: branchData.branch_name,
        branch_code: branchData.branch_code,
        branch_location: branchData.branch_location,
        branch_mobile: branchData.branch_mobile,
        branch_email: branchData.branch_email,
        branch_status: branchData.branch_status,
      };

      const response = await createBranch(singleBranch);

      if (response?.status === 200 && response.data) {
        dispatch({
          type: CONFIRMED_CREATE_BRANCH_ACTION,
          payload: singleBranch,
        });
        handleSuccess("Branch created successfully!");
      } else {
        showErrorAlert("Failed to create branch");
      }
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to create branch");
      throw error; // So calling component knows
    }
  };
}
  
export function updateBranchAction(branch, branchId) {
  return async (dispatch) => {
    try {
      const dataWithId = { ...branch, branch_id: branchId };
      const response = await updateBranch(dataWithId);

      if (response?.data) {
        dispatch({ type: CONFIRMED_EDIT_BRANCH_ACTION, payload: response.data });
        handleSuccess("Branch updated successfully!");
      } else {
        showErrorAlert("Failed to update branch");
      }
    } catch (error) {
      console.log("API Error:", error);
      showErrorAlert("Failed to update branch");
      throw error;
    }
  };
}



